import React, { useState, useEffect } from 'react';
import { Modal, Input, Checkbox } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';

import doneButtonImg from '../../public/img/newMessage/DoneButton.png'
import stdApplyingAvatar from '../../public/img/newMain/stdApplyingAvatar.png'

import '../../component/messageTwoImage/messageTwoImage.css'

const { TextArea } = Input;

let SelectStudenModal = (props) => {

    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [studentName, setStudentName] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        search(pageSize, 1);
    }, []);

    const search = (pageSizeNew, currentPageNew) => {
        let model = {
            "studentName": studentName,
            "progId": props.progId,
            cohortYear: Config?.cohort?.cohortYear
        };
        model.page = currentPageNew;
        model.pageSize = pageSizeNew;
        Base.callBackApi("partnerHome/searchStudentList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { });
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const columns = [
        {
            title: '',
            dataIndex: 'studentName',
            className: 'tableWidth80',
            render: (text, record) => <div className='userArea'>
                <div className='userAreaImg' >
                    <img src={stdApplyingAvatar}></img>
                </div>
                <div className='userAreaContext'>
                    <div className='userAreaContextTop'>
                        <text className='studentProgramme'>Student ID {record.studentAcctId}</text>
                    </div>
                    <div className='userAreaContextButtom'>
                        <text className='studentName'>{record.firstName + " " + record.lastName} </text>
                    </div>
                </div>
            </div>
        },
        {
            title: '',
            dataIndex: 'selected',
            className: 'tableWidth20',
            render: (text, record, index) =>
                <Checkbox className='isSelected' checked={text === "Y" ? true : false} onClick={(e) => handleRadioChange(e, text, record)} >
                </Checkbox>
        },
    ];

    const handleRadioChange = (e, rowId, model) => {
        let list = JSON.parse(JSON.stringify(tables));
        for (let item of list) {
            if (item.assignToUserId === model.assignToUserId) {
                if (item.selected === "Y") {
                    item.selected = "N";
                } else {
                    item.selected = "Y";
                }
            }
        }
        setTables(list);
    };

    const onSelectChange = selectedRowKeys => {
        setSelectedRowKeys(selectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        fixed: 'right', // 将多选列固定在表格的右侧
    };

    const save = () => {
        let studentAcctIdList = studentName?.split(',') ?? []
        let list = JSON.parse(JSON.stringify(tables));
        let filteredList = list.filter(item => studentAcctIdList.includes(item.studentAcctId));
        // 过滤出无效的 StudentID
        let notIncludedList = studentAcctIdList.filter(acctId => !filteredList.some(item => item.studentAcctId === acctId));
        if(notIncludedList.length === 0) {
            props.onClose(filteredList);
        } else {
            let errorMessage = `Student ID: ${notIncludedList.join(', ')} is invalid.`;
            setErrorMessage(errorMessage)
        }
        // let newList = []
        // for (let item of list) {
        //     if (item?.selected === 'Y') {
        //         newList.push(item);
        //     }
        // }
    }

    const selectRowNew = (record) => {
        let list = JSON.parse(JSON.stringify(tables));
        for (let item of list) {
            if (item.assignToUserId === record.assignToUserId) {
                if (item.selected === "Y") {
                    item.selected = "N";
                } else {
                    item.selected = "Y";
                }
            }
        }
        setTables(list);
    }

    const close = () => {
        props.onClose(null);
    }

    return (
        <Modal
            open={true}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageTwoImage4'
            width={735}
            centered
            closable={false}
        >
            <div className='closeModal' onClick={close}><CloseCircleOutlined /></div>
            <div className='messageTop'>
                <text className='messageTopTitle'>Assigned Students</text>
                <text className='messageTopTitle2'>Search by Student ID, seperated by comma</text>
            </div>
            {/* <div className='contentBox'>
                <div className='contentBoxInput'>
                    <Input style={{ height: '50px' }} value={studentName} 
                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1) : null}
                        onChange={(e) => setStudentName(e.target.value)} />
                </div>
                <div id="tableOne">
                    <Table
                        scroll={{ x: 687 }}
                        rowKey="assignToUserId"
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,         //是否显示可以设置几条一页的选项
                            onChange: onChange,            //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                            total: tablesCount,             //总共多少条数据
                            current: current,         //当前页
                            pageSize: pageSize,       //每页显示多少条数据
                            defaultCurrent: 1,        //默认当前页为1
                            size: "small"
                        }}
                        onRow={(record) => {
                            return {
                                onClick: event => selectRowNew(record),
                            };
                        }}
                    />
                </div>
            </div> */}
            <TextArea value={studentName}
                    rows={3}
                    onChange={(e) => setStudentName(e.target.value)} />
            {errorMessage && <div style={{color: '#D71920'}}>{errorMessage}</div>}
            <div className='messageButtom' style={{ marginTop: "10px" }}>
                <img src={doneButtonImg} className='doneButtonImg2' onClick={() => save()} />
            </div>
        </Modal>
    )

}

SelectStudenModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    checkboxState: PropTypes.array,
    progId: PropTypes.number,
};

export default SelectStudenModal;